const fonts = {
  regular: 400,
  medium: 500,
  semibold: 600,
};

export default fonts;
